export default {"src":"/_next/static/media/stadium-icon.d587a0eb.svg","height":58,"width":58};